import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Gallery, GalleryItem, ImageSize, ImageItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { MatSelect } from '@angular/material/select';

import { ReplaySubject, Subject } from 'rxjs';

import { take, takeUntil } from 'rxjs/operators';

// import { Bank, BANKS } from './demo-data';
import { Bank, BANKS } from './askanexpert-data';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { UserProfileComponent } from 'src/app/modals/user-profile/user-profile.component';
import { ViewDetailComponent } from 'src/app/modals/view-detail/view-detail.component';
export interface Element {
  postedDate: string;
  userName: string;
  state: string;
  district: string;
  sfUserID: number;
  sfTicketID: number;
  mobileNo: number;
}

interface sortBy {
  value: string;
  viewValue: string;
}
export interface BankGroup {
  name: string;
  banks: Bank[];
}
@Component({
  selector: 'app-ask-an-expert',
  templateUrl: './ask-an-expert.component.html',
  styleUrls: ['./ask-an-expert.component.scss'],
})
export class AskAnExpertComponent implements OnInit {
  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  statedata = [];
  latestTicketId;
  districtdata = [];
  filtershow = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns = [
    'postedDate',
    'userName',
    'state',
    'district',
    'sfUserID',
    'sfTicketID',
    'mobileNo',
  ];
  dataSource = new MatTableDataSource<Element>([]);
  reviewData;
  userdata;
  ExpertList = [];
  ExpertListData;
  askExpertData: any = [];

  selectedSorting: string;
  selectFilterData1;
  today = new Date();

  customDate = false;
  currentD = this.datePipe.transform(this.today, 'dd/MM/yyyy');
  datepicker = [
    {
      value: '0',
      viewValue: '1 Week',
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      endDate: new Date(),
    },
    {
      value: '1',
      viewValue: '1 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
    },
    {
      value: '2',
      viewValue: '3 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
      endDate: new Date(),
    },
    {
      value: '3',
      viewValue: '6 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 180)),
      endDate: new Date(),
    },
    {
      value: '4',
      viewValue: '1 Year',
      startDate: new Date(new Date().setDate(new Date().getDate() - 365)),
      endDate: new Date(),
    },
    { value: '5', viewValue: 'Custom Date' },
  ];
  sortBy = [
    { value: '0', viewValue: 'Most Recent' },
    { value: '1', viewValue: 'Oldest Rating' },
    { value: '2', viewValue: 'Highest Rating' },
    { value: '3', viewValue: 'Lowest Rating' },
  ];

  filterData = [{ value: '1', viewValue: 'State' }];
  ranges: any = {
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()],
  };
  public matChipArray = [];
  selectFilterData;
  searchData;
  filterbyText = '';
  filterbycategoryName = '';
  filterbystate = [];
  filterbydistrict = [];
  filterbydistrictName = '';
  filterbyphone = '';
  dataSourcelist;
  apidata;
  newData: any = [];

  exportcsvdata = false;

  totalAskTicket: any = [];
  formdate = '';
  filterbyformdate = '';
  filterbytodayte = '';
  todayte = '';

  filterbynamedata = '';
  namedata = '';
  state = '';
  district = '';
  length: number;

  categoryName: string;

  datashow = true;
  datashowtrader = false;
  datashowfarmer = false;
  avtar = false;
  Viewprofile = false;
  ViewDetail = false;
  datarole: string;
  hidepagination: boolean;

  maxDate;
  minDate;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  regexStr: string | RegExp;
  submitted: boolean;
  reg: string | RegExp;
  response: Object;
  /** list of banks */
  protected banks: Bank[] = BANKS;

  /** total number of available entries */
  public allBanksSize = BANKS.length;

  /** control for the selected bank for multi-selection */
  public bankMultiCtrl: FormControl = new FormControl();

  public districtMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public bankMultiFilterCtrl: FormControl = new FormControl();

  public districtMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredBanksMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(
    1
  );

  public filteredDistrictMulti: ReplaySubject<Bank[]> = new ReplaySubject<
    Bank[]
  >(1);

  /** local copy of filtered banks to help set the toggle all checkbox state */
  protected filteredBanksCache: Bank[] = [];

  protected filteredDistrictCache = [];
  isIndeterminateDistrict = false;
  isCheckedDistrict = false;
  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;
  @ViewChild('multiSelectDistrict', { static: true })
  multiSelectDistrict: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();
  sharedate;
  mobiledata;

  filterbysharedate = '';

  constructor(
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    public gallery: Gallery,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef,
    public dialog: MatDialog
  ) {}
  categoryForm: FormGroup;
  ngOnInit(): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this.selectedSorting = this.sortBy[0].viewValue;
    this.totalTicket();
    this.getExpertList();

    this.filteredBanksMulti.next(this.banks.slice());

    this.filteredDistrictMulti.next(this.selectDistrict.slice());

    this.bankMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
        this.setToggleAllCheckboxState();
      });

    this.districtMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDistrictMulti();
        this.districtSetToggleAllCheckboxState();
      });

    this.districtMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.districtSetToggleAllCheckboxState();
      });

    // listen for multi select field value changes
    this.bankMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.setToggleAllCheckboxState();
      });
  }
  suche() {
    setTimeout(() => {
      (document.querySelectorAll('#search1 div input')[1] as any).placeholder =
        'Search State';
    }, 5);
  }

  notFound() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll('#search1>div')[1] as any).innerText =
          'not found';
      }, 10);
    }
  }
  notFoundDistrict() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll('#search1>div')[1] as any).innerText =
          'not found';
      }, 10);
    }
  }
  sucheDistrict() {
    setTimeout(() => {
      (document.querySelectorAll('#search1 div input')[1] as any).placeholder =
        'Search District';
    }, 5);
  }
  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  protected setInitialValue() {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelect.compareWith = (a: Bank, b: Bank) =>
          a && b && a.id === b.id;
      });
  }

  protected districtSetInitialValue() {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelectDistrict.compareWith = (a: Bank, b: Bank) =>
          a && b && a.id === b.id;
      });
  }

  protected filterBanksMulti() {
    if (!this.banks) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBanksCache = this.banks.slice();
      this.filteredBanksMulti.next(this.filteredBanksCache);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredBanksCache = this.banks.filter(
      (bank: any) => bank.stateName.toLowerCase().indexOf(search) > -1
    );
    this.filteredBanksMulti.next(this.filteredBanksCache);
  }

  protected filterDistrictMulti() {
    if (!this.eligbleDistricts()) {
      return;
    }
    // get the search keyword
    let search = this.districtMultiFilterCtrl.value;
    if (!search) {
      this.filteredDistrictCache = this.eligbleDistricts().slice();
      this.filteredDistrictMulti.next(this.filteredDistrictCache);
      this.selectDistrict = this.filteredDistrictCache;
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredDistrictCache = this.eligbleDistricts().filter(
      (item: any) => item.toLowerCase().indexOf(search) > -1
    );
    this.filteredDistrictMulti.next(this.filteredDistrictCache);
    this.selectDistrict = this.filteredDistrictCache;
  }

  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.bankMultiCtrl && this.bankMultiCtrl.value) {
      this.filteredBanksCache.forEach((el) => {
        if (this.bankMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredBanksCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredBanksCache.length;
    }
  }

  protected districtSetToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.districtMultiCtrl && this.districtMultiCtrl.value) {
      this.filteredDistrictCache.forEach((el) => {
        if (this.districtMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDistrict =
        filteredLength > 0 &&
        filteredLength < this.filteredDistrictCache.length;
      this.isCheckedDistrict =
        filteredLength > 0 &&
        filteredLength === this.filteredDistrictCache.length;
    }
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.bankMultiCtrl.patchValue(val);
        } else {
          this.bankMultiCtrl.patchValue([]);
        }
      });
  }

  toggleSelectAlldistrict(selectAllValue: boolean) {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.districtMultiCtrl.patchValue(this.eligbleDistricts());
        } else {
          this.districtMultiCtrl.patchValue([]);
        }
      });
  }

  selectDistrict = [];

  filterMyOptions(items) {
    this.selectDistrict = [];
    if (this.bankMultiCtrl.value.length === 0) {
    } else {
      this.bankMultiCtrl.value.forEach((element) => {
        this.selectDistrict = this.selectDistrict.concat(element.districtName);
      });
    }
  }

  eligbleDistricts() {
    let dist = [];
    if (this.bankMultiCtrl.value.length === 0) {
    } else {
      this.bankMultiCtrl.value.forEach((element) => {
        dist = dist.concat(element.districtName);
      });
    }
    return dist;
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  getExpertList() {
    this.spinner.show();
    var postdata = {
      fromDate: '',
      todate: '',
      categoryName: '',
      search: '',
      mobileNo: '',
      state: '',
      district: '',
      pageNumber: 0,
      pageSize: 10,
      reportKeyList: [],
    };

    this._userService.getAskAnExpertRecord(postdata).subscribe((data) => {
      this.newData = data;
      // this.askExpertData = this.newData.result.data.list
      this.paginationProperty = this.newData.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.totalPages = this.paginationProperty.totalPages;
      this.dataSource = new MatTableDataSource<Element>(
        this.newData.result.data.list
      );

      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });
  }

  totalTicket() {
    this._userService.getTotalCount().subscribe((data) => {
      this.reviewData = data;
      this.totalAskTicket = this.reviewData.result.data;
    });
  }
  startdata;
  enddata;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'dd/MM/yyyy')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'dd/MM/yyyy')
        : null;
    }
  }

  /*......................Pagination.................*/
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;

  previousPageIndex;
  pagechangeevent;
  searchText = '';
  searchDate = '';

  public getServerData(event?: PageEvent) {
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;
    if (this.exportcsvdata == true) {
      var postdata = {
        search: this.filterbyText,
        fromDate: this.startdata,
        todate: this.enddata,
        categoryName: this.filterbycategoryName,
        mobileNo: this.filterbyphone,
        state: this.filterbystate.join(','),
        district: this.filterbydistrict.join(','),
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        reportKeyList: [],
      };
      this._userService.getAskAnExpertRecord(postdata).subscribe((data) => {
        this.userdata = data;
        this.newData = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.newData);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    } else {
      postdata = {
        search: '',
        fromDate: this.datePipe.transform(
          this.form.controls.start.value,
          'yyyy-MM-ddThh:mm:ss'
        ),
        todate: this.datePipe.transform(
          this.form.controls.end.value,
          'yyyy-MM-ddThh:mm:ss'
        ),
        categoryName: '',
        mobileNo: '',
        state: '',
        district: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        reportKeyList: [],
      };
      this._userService.getAskAnExpertRecord(postdata).subscribe((data) => {
        this.userdata = data;
        this.newData = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.newData);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }
  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }

  applyFilter(checkEmpty) {
    this.matChipArray = [];
    let totalState = [];
    this.statedata.forEach((ele: any) => {
      totalState.push(ele.stateName);
    });

    if (
      checkEmpty &&
      !this.searchData &&
      totalState.length == 0 &&
      this.districtdata.length == 0 &&
      !this.sharedate.endDate &&
      !this.sharedate.startDate
    ) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbyformdate = this.formdate;
      // this.filterbytodayte = this.datePipe.transform(this.todayte, 'yyyy/MM/dd hh:mm:ss');
      // this.filterbyformdate = this.enddata;
      // this.filterbytodayte = this.startdata;
      this.filterbysharedate = this.sharedate;

      this.filterbystate = totalState;
      this.filterbydistrict = this.districtdata;

      this.filterbycategoryName = this.categoryName;
      this.filterbyphone = this.mobiledata;
      let indexcategoryName = this.matChipArray.findIndex(
        (x) => x.tag === 'categoryName'
      );
      let indexstate = this.matChipArray.findIndex((x) => x.tag === 'state');
      let indexdistrictdata = this.matChipArray.findIndex(
        (x) => x.tag === 'district'
      );
      let indexmobiledata = this.matChipArray.findIndex(
        (x) => x.tag === 'mobiledata'
      );

      //let indexcategoryname = this.matChipArray.findIndex(x => x.tag === 'categoryname');
      let indexformdate = this.matChipArray.findIndex(
        (x) => x.tag === 'formdate'
      );
      let indextodayte = this.matChipArray.findIndex(
        (x) => x.tag === 'todayte'
      );
      let indexsharedate = this.matChipArray.findIndex(
        (x) => x.tag === 'sharedate'
      );
      if (this.categoryName != '') {
        if (indexcategoryName > -1) {
          this.matChipArray[indexcategoryName].name =
            'Name' + ':' + this.categoryName;
        } else {
          if (this.categoryName != '' && this.categoryName != undefined) {
            this.matChipArray.push({
              name: 'Name' + ':' + this.categoryName,
              tag: 'categoryName',
              flag: true,
            });
          }
        }
      }

      if (this.mobiledata != '') {
        if (indexmobiledata > -1) {
          this.matChipArray[indexmobiledata].name =
            'Mobile' + ':' + this.mobiledata;
        } else {
          if (this.mobiledata != '' && this.mobiledata != undefined) {
            this.matChipArray.push({
              name: 'Mobile' + ':' + this.mobiledata,
              tag: 'mobiledata',
              flag: true,
            });
          }
        }
      }
      if (totalState != null) {
        totalState.forEach((ele) => {
          // if (ele.indexstate > -1) {
          //   this.matChipArray[ele.indexstate].name = "State" + ":" + totalState;
          // } else {
          //   if (totalState != null && totalState != undefined) {
          //     this.matChipArray.push({ 'name': "State" + ":" + totalState, 'tag': 'state', 'flag': true })
          //   }
          // }
          this.matChipArray.push({
            name: 'State' + ':' + ele,
            tag: 'state',
            flag: true,
          });
        });
      }

      if (this.districtdata != null) {
        this.districtdata.forEach((ele) => {
          this.matChipArray.push({
            name: 'District' + ':' + ele,
            tag: 'district',
            flag: true,
          });
        });
      }

      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('DD/MM/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('DD/MM/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('DD/MM/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('DD/MM/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }
      var postdata = {
        search: this.filterbyText,
        fromDate: this.startdata,
        todate: this.enddata,
        categoryName: this.filterbycategoryName,
        mobileNo: this.filterbyphone,
        state: this.filterbystate.join(','),
        district:
          this.filterbydistrict && this.filterbydistrict.length > 0
            ? this.filterbydistrict.join(',')
            : '',
        pageNumber: 0,
        pageSize: 10,
        reportKeyList: [],
      };

      this._userService.getAskAnExpertRecord(postdata).subscribe((data) => {
        this.newData = data;
        this.paginationProperty = this.newData.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.totalPages = this.paginationProperty.totalPages;
        this.dataSource = new MatTableDataSource<Element>(
          this.newData.result.data.list
        );
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }

  remove(index, tag): void {
    if (tag === 'categoryName') {
      this.matChipArray.splice(index, 1);
      this.categoryName = '';
    }
    if (tag === 'mobiledata') {
      this.matChipArray.splice(index, 1);
      this.mobiledata = '';
    }

    if (tag === 'state') {
      let removedState: any = this.matChipArray.splice(index, 1);
      // this.totalState = "";
      let val = JSON.parse(JSON.stringify(this.statedata));
      let i = val.findIndex(
        (x) => removedState[0].name === 'State:' + x.stateName
      );
      val.splice(i, 1);
      // this.bankMultiCtrl.setValue([]);
      this.bankMultiCtrl.setValue(val);
      // this.bankMultiCtrl.setValue(this.statedata);
    }
    if (tag === 'district') {
      let removedDistrict: any = this.matChipArray.splice(index, 1);
      let val = JSON.parse(JSON.stringify(this.districtdata));
      let i = val.findIndex(
        (x) => removedDistrict[0].name === 'District:' + x.districtName
      );
      val.splice(i, 1);
      this.districtMultiCtrl.setValue(val);
    }
    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
    }

    this.applyFilter(false);
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  companyname;
  documentStatus;
  mandi;
  personName;
  phoneNo;
  role;
  states;
  taluk;
  numberOfTrees;
  treeType;
  commTradeInterest;
  reqFrequency;
  aboutUs;
  profile_Image;
  address;
  showDocument(data) {
    this.datashowtrader = false;
    this.datashow = false;
    this.datashowfarmer = true;
    this.avtar = false;
    this.Viewprofile = true;
    if (data.role == 'TRADER') {
      this.datashowtrader = true;
      this.datashowfarmer = false;
    }
    if (data.profile_Image == null) {
      this.avtar = true;
    }
    this.companyname = data.company;
    this.documentStatus = data.documentStatus;
    this.mandi = data.mandi;
    this.personName = data.personName;
    this.phoneNo = data.phoneNo;
    this.role = data.role;
    this.states = data.states;
    this.district = data.district;
    this.taluk = data.taluk;
    this.numberOfTrees = data.numberOfTrees;
    this.treeType = data.treeType;
    this.commTradeInterest = data.commTradeInterest;
    this.reqFrequency = data.reqFrequency;
    this.aboutUs = data.aboutUs;
    this.profile_Image = data.profile_Image;
    this.address = data.address;
    this.documentStatus = data.documentStatus;
  }

  showViews() {
    // this.spinner.show();
    // window.location.reload();
    this.datashow = true;
    this.Viewprofile = false;
    this.ViewDetail = false;
    this.spinner.show();
    var postdata = {
      fromDate: '',
      todate: '',
      state: '',
      district: '',
      search: '',
      categoryName: '',
      pageNumber: 0,
      pageSize: 10,
      mobileNo: '',
      reportKeyList: [],
    };
    this._userService.getAskAnExpertRecord(postdata).subscribe((data) => {
      this.userdata = data;
      this.ExpertList = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;

      this.dataSource = new MatTableDataSource(this.ExpertList);
      // this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //setTimeout(() => this.dataSource.sort = this.sort);

      this.spinner.hide();
    });
  }

  latestTicketID;
  imageList;
  userName;
  userID;
  userComment;
  mobileNo;
  sfUserID;
  sfTicketID;
  postedDate;

  showViewsDetail(value) {
    // this.spinner.show();
    // window.location.reload();
    this.datashow = true;
    this.ViewDetail = false;
    this.spinner.show();
    // var postdata = {
    //   "fromDate": "",
    //   "todate": "",
    //   "state": "",
    //   "district": "",
    //   "search": "",
    //   "categoryName": "",
    //   "pageNumber": 0,
    //   "pageSize": 10,
    //   "mobileNo": "",
    //   "reportKeyList":[]

    // }
    this._userService.getTicketDetail(value.sfTicketID).subscribe((data) => {
      this.userdata = data;
      this.ExpertList = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;

      this.dataSource = new MatTableDataSource(this.ExpertList);
      // this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //setTimeout(() => this.dataSource.sort = this.sort);

      this.spinner.hide();
    });
  }
  formatDate(datetime) {
    return (
      datetime.split(' ')[0] +
      ' ' +
      datetime.split(' ')[1] +
      ' ' +
      datetime.split(' ')[2]
    );
  }
  /*====================================================View Profile ================================================================ */
  city: string;
  name: string;
  food_from_modal: string;

  openTicketDialog(value) {
    this.spinner.show();

    this._userService.getTicketDetail(value.sfTicketID).subscribe((data) => {
      if (data['result'].data) {
        this.latestTicketId = data['result'].data.latestTicketID;
        if (this.latestTicketId === value.sfTicketID) {
          // this.toastr.success(`Your Latest Ticket Id :${this.latestTicketId}`, 'Info', {
          //   timeOut: 3000,
          // });
        } else {
          var dialogRef = this.dialog.open(TicketDetail, {
            width: '27%',
            height: '28%',
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result == 'Yes') {
              this._userService
                .getTicketDetail(value.sfTicketID)
                .subscribe((data) => {});
            }
          });
        }
        this.spinner.hide();
      } else {
        // this.latestTicketId = 'Not Found'
        this.spinner.hide();
      }
    });
  }

  openDialog(data): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
    const dialogRef = this.dialog.open(UserProfileComponent, {
      width: '60%',
      height: '71%',
      data: { name: data.userID },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  openDialogDetail(data): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
    const dialogRef = this.dialog.open(ViewDetailComponent, {
      width: '40%',
      height: 'auto',
      data: { name: data.sfTicketID },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  exportcsv() {
    if (this.exportcsvdata == true) {
      this.applyFilter(false);
      var postdata = {
        fromDate: this.filterbyformdate,
        todate: this.filterbytodayte,
        categoryName: this.filterbycategoryName,
        mobileNo: this.filterbyphone,
        state: this.filterbystate,
        district: this.filterbydistrictName,
        search: this.filterbyText,
        reportKeyList: [],
      };

      this._userService.getAskAnExpertReport(postdata).subscribe((data) => {
        // this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Expertlist.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
      });
    } else {
      var postdata = {
        fromDate: this.filterbyformdate,
        todate: this.filterbytodayte,
        categoryName: this.filterbycategoryName,
        mobileNo: this.filterbyphone,
        state: this.filterbystate,
        district: this.filterbydistrictName,
        search: this.filterbyText,
        reportKeyList: [],
      };
      this._userService.getAskAnExpertReport(postdata).subscribe((data) => {
        // this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Expertlist.xlsx';
        anchor.href = url;
        anchor.click();
      });
    }
  }

  selectItem(item) {
    if (item.value == 'Custom Date') {
      this.customDate = true;
    } else {
      this.customDate = false;
    }
  }
  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyFilter(false);
    }
  }

  dialogresult;
  mainresult;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(AskExportData, {
      width: '60%',
      height: 'auto',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;

      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);
          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyFilter(false);

              var postdata = {
                fromDate: this.startdata,
                todate: this.enddata,
                categoryName: this.filterbycategoryName,
                mobileNo: this.filterbyphone,
                state: this.filterbystate.join(','),
                district: this.filterbydistrict.join(','),
                search: this.filterbyText,
                reportKeyList: Result,
              };
              this._userService
                .getAskAnExpertReport(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  var anchor = document.createElement('a');
                  anchor.download = 'PKF_Expertlist.xlsx';
                  anchor.href = url;
                  anchor.click();
                });
            } else {
              postdata = {
                fromDate: this.startdata,
                todate: this.enddata,
                categoryName: '',
                mobileNo: '',
                state: '',
                district: '',
                search: '',
                reportKeyList: Result,
              };

              this._userService
                .getAskAnExpertReport(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  var anchor = document.createElement('a');
                  anchor.download = 'PKF_Expertlist.xlsx';
                  anchor.href = url;
                  anchor.click();
                });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport();
        }
      }
      //================================REPORT GENERATE==========================================//
    });
  }
}

/* ===========================================Export-function ==============================================================*/

@Component({
  selector: 'ask-export-data',
  templateUrl: 'ask-export-data.html',
})
export class AskExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<AskExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      // { id: 1, value: 'UserID', isSelected: false },
      { id: 2, value: 'UserName', isSelected: false },
      { id: 3, value: 'SFUserID', isSelected: false },
      { id: 4, value: 'SFTicketID', isSelected: false },
      { id: 5, value: 'PostedDate', isSelected: false },
      { id: 6, value: 'MobileNo', isSelected: false },
      { id: 7, value: 'State', isSelected: false },
      { id: 8, value: 'District', isSelected: false },
    ];
    this.getCheckedItemList();
  }
  //  onNoClick(): void {
  //   // this.dialogRef.close();
  //  }
  ngOnInit(): void {
    // this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'ticket-detail',
  templateUrl: 'ticket-detail.html',
})
export class TicketDetail {
  formDetail: FormGroup;
  response;
  categoryId;
  constructor(
    public dialogRef: MatDialogRef<TicketDetail>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.formDetail = this.fb.group({
      //  categoryID: ['', [Validators.required]],
      // categoryName: ['', [Validators.required]],
      // Remark: ['', [Validators.required]],
    });
  }
  onSubmit(value): void {
    this.dialogRef.close(value);
  }

  onNoClicks(value): void {
    this.dialogRef.close(value);
  }
}
